import { useState } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import '../styles/Navbar.css'
import { useTwitchStatus } from '../hooks/useTwitchStatus'
import { FaTwitch } from 'react-icons/fa'

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { isLive, streamData } = useTwitchStatus();
  const location = useLocation();
  const navigate = useNavigate();
  const isHomePage = location.pathname === '/';

  const handleNavigation = (sectionId) => {
    setIsMenuOpen(false); // Close menu after clicking
    
    if (isHomePage) {
      // If we're on the home page, scroll to the section
      const element = document.getElementById(sectionId);
      if (element) {
        const navHeight = 80; // Height of the navbar
        const elementPosition = element.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - navHeight;

        window.scrollTo({
          top: offsetPosition,
          behavior: "smooth"
        });
      }
    } else {
      // If we're on another page, navigate to home page with hash
      navigate(`/#${sectionId}`);
    }
  }

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <div className="navbar-left">
          <div className="navbar-logo" onClick={() => {
              if (isHomePage) {
                handleNavigation('hero');
              } else {
                navigate('/');
              }
            }}>
            <img src="/images/thelostloft-logo-white.png" alt="The Lost Loft" />
          </div>
          {isLive && streamData && (
            <a 
              href={streamData.url}
              target="_blank"
              rel="noopener noreferrer"
              className="nav-link live"
            >
              <FaTwitch className="twitch-icon" />
              LIVE
            </a>
          )}
        </div>

        <div className="hamburger" onClick={() => setIsMenuOpen(!isMenuOpen)}>
          <span className={`bar ${isMenuOpen ? 'open' : ''}`}></span>
          <span className={`bar ${isMenuOpen ? 'open' : ''}`}></span>
          <span className={`bar ${isMenuOpen ? 'open' : ''}`}></span>
        </div>

        <ul className={`nav-menu ${isMenuOpen ? 'active' : ''}`}>
          <li className="nav-item">
            <div className="nav-link" onClick={() => {
              if (isHomePage) {
                handleNavigation('hero');
              } else {
                navigate('/');
              }
            }}>
              Home
            </div>
          </li>
          <li className="nav-item">
            <div className="nav-link" onClick={() => handleNavigation('about')}>
              About
            </div>
          </li>
          <li className="nav-item">
            <div className="nav-link" onClick={() => handleNavigation('upcoming-events')}>
              Events
            </div>
          </li>
          <li className="nav-item">
            <div className="nav-link" onClick={() => handleNavigation('artists')}>
              Artists
            </div>
          </li>
          <li className="nav-item">
            <Link to="/mixes" className="nav-link">
              Mixes
            </Link>
          </li>
          <li className="nav-item">
            <Link to="/releases" className="nav-link">
              Releases
            </Link>
          </li>
          <li className="nav-item">
            <div className="nav-link" onClick={() => handleNavigation('connect')}>
              Connect
            </div>
          </li>
        </ul>
      </div>
    </nav>
  )
}

export default Navbar
